import { createModel } from '@rematch/core';
import { BlogType, PaginationType, RootModel } from '@types';
import { BlogService } from '@services';
import baseEntity from './base.entity';
import { Dispatch } from '@redux/store';

interface BlogStateType {
  ids: { [id: number]: BlogType };
}

export const blogEntities = createModel<RootModel>()({
  state: { ids: {} } as BlogStateType,
  reducers: {
    ...baseEntity,
  },
  effects: (dispatch: Dispatch) => ({
    async load(payload): Promise<{ content: BlogType[] } & PaginationType> {
      const res = await BlogService.filter(payload);
      const { content } = res.data;
      if (content && content.length) {
        this.saveSimplified(content);
      }
      return res.data;
    },
    async findById(payload, state): Promise<BlogType> {
      const item = state.blogEntities.ids[payload];
      if (item && !item.simplified) {
        return item;
      }
      const res = await BlogService.getById(payload);
      this.saves([res.data]);
      return res.data;
    },
    async delete(payload) {
      await BlogService.deleteById(payload);
      this.remove({ id: payload });
    },
    async save(payload) {
      let item;
      if (!payload.id) {
        ({ data: item } = await BlogService.create(payload));
      } else {
        ({ data: item } = await BlogService.update(payload.id, payload));
      }
      this.update(item);
      return item;
    },
    async publish(payload) {
      const { data } = await BlogService.publish(payload);
      this.update(data);
      return data;
    },
  }),
});
